// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styledBoxStyle } from "@stoneage/App/Components/Common/StyledBox";
import { accountSettingsDefaultBillingShippingStyles } from "@stoneage/Overrides/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping";
import { xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

accountSettingsDefaultBillingShippingStyles.pickUpLocation = {
    ...accountSettingsDefaultBillingShippingStyles.pickUpLocation,
    gridContainer: {
        gap: 5,
        css: css`
            display: flex;
            height: 100%;
        `,
        offsetCss: css`
            &&& {
                display: flex;
                flex-direction: column;
                flex-wrap: unset;
            }
        `,
    },
    headingGridItem: {
        width: 12,
        css: css`
            &&& {
                margin-bottom: 16px;
                flex: 0 1 auto;
            }
        `,
    },
    changeLink: {
        css: css`
            margin-left: 10px;
            margin-top: 0;
        `,
    },
    warehouseGridItem: {
        width: 12,
        css: css`
            border-radius: 4px;
            ${styledBoxStyle}
            ${xScreen("lte", "sm")} {
                max-width: 500px;
            }
        `,
    },
};

accountSettingsDefaultBillingShippingStyles.customerSelectorGridContainer = {
    gap: 15,
    css: css`
        margin-bottom: 15px;
        margin-left: 0;
        padding: 15px;
    `,
};

accountSettingsDefaultBillingShippingStyles.customerSelectorGridItem = {
    width: [12, 12, 12, 8, 8],
    css:css`
        ${styledBoxStyle}
        &&&& {
            margin-bottom: 16px;
        }
    `
};

accountSettingsDefaultBillingShippingStyles.warehouseAddressWrapper = {
    width: 12
};

accountSettingsDefaultBillingShippingStyles.centeringWrapper = {
    css: css`
        height: 300px;
        display: flex;
        align-items: center;
        width: 100%;
    `,
};

accountSettingsDefaultBillingShippingStyles.spinner = {
    css: css`
        margin: auto;
    `,
};
